<template>
    <div class="container pb-5">
        <!-- Page title -->
        <div class="pt-5 pb-5">
            <h1 class="m-0">Winkelmandje</h1>
        </div>
        <!-- End Page title -->

        <!-- Message -->
        <div
            class="message warning"
            v-if="items != null && items.length == 0"
        >Uw winkelmandje is momenteel leeg.</div>
        <!-- End Message -->

        <div class="row" v-else>
            <div class="col-lg-8">
                <!-- Cart -->
                <div class="panel">
                    <!-- Cart Item -->
                    <loader v-if="items == null"></loader>
                    <div v-else>
                        <h3 class="mb-3">Inhoud</h3>
                        <div class="mb-4" v-for="(item, index) in items" :key="index">
                            <cart-item :item="item" :index="index" @removed="removeItem(index)"></cart-item>
                        </div>
                    </div>
                    <!-- End Cart Item -->
                </div>
                <!-- End Cart -->
            </div>
            <div class="col-lg-4">
                <div class="panel">
                    <div class="form-group mb-30">
                        <label>Opmerkingen</label>
                        <textarea rows="5" class="form-control" v-model="notes"></textarea>
                    </div>

                    <table class="cart__totals mb-30">
                        <tr v-if="currentUser">
                            <td>Account</td>
                            <td>{{ currentUser.name }}</td>
                        </tr>
                    </table>
                    <button
                        href="#"
                        @click.prevent="placeOrder"
                        class="btn btn--accent btn--block"
                        :disabled="placingOrder"
                    >
                        <i class="fa fa-spin fa-circle-o-notch mr-1" v-if="placingOrder"></i> Bestellen
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        totalCount() {
            var total = 0;

            if (this.items != null) {
                for (var item in this.items) {
                    if (this.items.hasOwnProperty(item)) {
                        total += parseInt(item.quantity);
                    }
                }
            }

            return total;
        },

        currentUser() {
            return this.$store.getters.user;
        },

        isEmpty() {
            return this.items != null && this.items.length == 0;
        }
    },
    data() {
        return {
            items: null,
            files: null,
            placingOrder: false,
            notes: ""
        };
    },
    mounted() {
        this.getCart();
    },
    methods: {
        getCart() {
            this.$http
                .get("/cart")
                .then(res => {
                    this.items = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        removeItem(index) {
            this.$delete(this.items, index);
        },
        placeOrder() {
            if (this.placingOrder) {
                return false;
            }
            this.placingOrder = true;

            this.$http
                .post("/orders", {
                    notes: this.notes
                })
                .then(res => {
                    console.log(res);
                    this.placingOrder = false;
                    this.$store.commit('clearStaffId');
                    this.$router.push({
                        name: "page",
                        params: { slug: "bedankt" }
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.placingOrder = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.cart__totals {
    width: 100%;

    tr {
        td {
            padding: 3px 0;

            &:first-of-type {
                font-weight: bold;
                color: $dark;
            }

            &:nth-of-type(2) {
                text-align: right;
            }
        }
    }
}
</style>
